import styled from 'styled-components'

import Table from '../../../../Table'

export const StyledTable = styled(Table)(({ theme }) => ({
  '.noWrapColumn, button': {
    whiteSpace: 'nowrap',
  },
  'tbody tr:hover': {
    backgroundColor: theme.colors.coolGray.cool100,
  },
  td: {
    padding: '0px',
  },
  a: {
    textDecoration: 'none',
    padding: '20px 4px 20px 4px',
    display: 'block',
    width: '100%',
  },
  // Because the See Related Order column is not shown on mobile this column needs to act as if it
  // is the final column on mobile to keep the spacing appearance of each row consistent:
  '.totalColumn': {
    paddingRight: '10px',
    wordBreak: 'keep-all',
  },
  '.textRight': {
    textAlign: 'right',
  },
  '@media(min-width: 992px)': {
    '.totalColumn': {
      paddingRight: '4px',
    },
  },
}))
